import React, { useRef, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import globeVideo from '../assets/AdobeStock_133145383_Video_HD_Preview.mov';

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
`;

const LogoContainer = styled.div`
  position: relative;
  width: 400px;
  height: 400px;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  overflow: hidden;
  mask-image: radial-gradient(circle at center, black 0%, black 50%, transparent 100%);
  -webkit-mask-image: radial-gradient(circle at center, black 0%, black 50%, transparent 100%);
  background: transparent;
  z-index: 2;
`;

const GlobeVideo = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
  mix-blend-mode: screen;
  z-index: 3;
  opacity: 0.8;
`;

const GlowEffect = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: radial-gradient(circle at center, rgba(0,149,255,0.1) 0%, rgba(0,149,255,0) 70%);
  animation: ${pulse} 4s ease-in-out infinite;
  pointer-events: none;
  z-index: 1;
`;

const ErrorText = styled.div`
  color: red;
  position: absolute;
  bottom: -20px;
  font-size: 12px;
`;

const Logo: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [videoUrl, setVideoUrl] = useState<string>('');

  useEffect(() => {
    // Create a blob URL for the video
    fetch(globeVideo)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);
        setVideoUrl(url);
        console.log('Video URL created:', url);
      })
      .catch(error => {
        console.error('Error loading video:', error);
      });

    // Cleanup
    return () => {
      if (videoUrl) {
        URL.revokeObjectURL(videoUrl);
      }
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.addEventListener('loadeddata', () => {
        console.log('Video loaded successfully');
        video.play().catch(e => console.error('Error playing video:', e));
      });
      
      video.addEventListener('error', (e) => {
        console.error('Video error event:', e);
        console.error('Video error message:', video.error?.message);
        console.error('Video error code:', video.error?.code);
      });
    }

    return () => {
      if (video) {
        video.removeEventListener('loadeddata', () => {});
        video.removeEventListener('error', () => {});
      }
    };
  }, [videoUrl]);

  return (
    <LogoContainer>
      <GlowEffect />
      <VideoContainer>
        {videoUrl && (
          <GlobeVideo
            ref={videoRef}
            autoPlay
            loop
            muted
            playsInline
            src={videoUrl}
          />
        )}
      </VideoContainer>
    </LogoContainer>
  );
};

export default Logo; 